<template>
  <div>
    <el-dialog title="提示" :visible.sync="delVisible" width="30%" :before-close="handleClose">
      <div class="del-dialog-cnt">删除不可恢复，是否确定删除？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerVisible">取 消</el-button>
        <el-button type="primary" @click="deleVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    delVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    centerVisible() {
      this.$emit('handleCloseVisible')
    },
    deleVisible() {
      this.$emit("deleteData");
    },
    handleClose() {
      this.$emit('handleCloseVisible')
    }
  }
};
</script>